import { retrieveToken } from '../storage';
import { wrapFetch, apiFetch, apiError } from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getUltimoStoricoPricing = (esercizioId) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/storico/${esercizioId}`;
  const URL = BASE_URL + PATH;

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
